module.exports = "/assets/kinley-page/hero.jpg?FvJJsnk";